export default __webpack_public_path__ + "static/media/DBA-ingénierie-et-business-ISEN-Lille.fadc4068.jpg";